import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

import { EVENT_LOG_API_URL } from '@/constants';
import { apiUrl, getQueryParams } from '@/helpers';
import { ErrorResponse, EventLogsPayload, Options } from '@/types';

export const eventLogEndpoints = {
  exportEventLogs: (orgId: number, startDate: Date, endDate: Date) =>
    axios.get(
      `${apiUrl()}${EVENT_LOG_API_URL}/export${getQueryParams({
        orgId: orgId,
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString()
      })}`,
      { responseType: 'blob' }
    )
};

export const useExportEventLogsMutation = (options: Options) => {
  return useMutation(
    ({ orgId, startDate, endDate }: EventLogsPayload) =>
      eventLogEndpoints.exportEventLogs(orgId, startDate, endDate),
    {
      onSuccess: (response) => {
        options.onSuccess(response);
      },
      onError: (error) => {
        options.onError(error as ErrorResponse);
      }
    }
  );
};
